// swalShim.js — OK/Cancel 전용, 가운데 정렬 + 아이콘 지원, zero deps
(function () {
  function _escapeHtml(s) {
    s = String(s);
    return s.replace(/&/g,"&amp;").replace(/</g,"&lt;")
            .replace(/>/g,"&gt;").replace(/"/g,"&quot;")
            .replace(/'/g,"&#39;");
  }

  function _injectStylesOnce() {
    if (document.getElementById("swal-lite-style")) return;
    var css = [
      ".swal-lite{padding:0;border:none;background:transparent}",
      ".swal-lite::backdrop{background:rgba(15,23,42,.45);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}",
      ".swal-card{background:#fff;color:#0f172a;border-radius:14px;box-shadow:0 20px 50px rgba(2,6,23,.25);width:min(92vw,420px);overflow:hidden;transform:translateY(8px) scale(.98);opacity:0;animation:swal-pop .18s ease-out forwards}",
      ".swal-header{display:flex;flex-direction:column;align-items:center;text-align:center;gap:10px;padding:20px 20px 8px}",
      ".swal-icon{width:42px;height:42px;color:#f59e0b}",
      ".swal-title{font-size:18px;font-weight:700;margin:0}",
      ".swal-content{padding:6px 20px 0 20px;font-size:14px;line-height:1.55;color:#334155;text-align:center}",
    //   ".swal-actions{display:flex;gap:10px;justify-content:flex-end;padding:18px 20px 20px 20px;background:#f8fafc}",
      ".swal-actions{display:flex;gap:10px;justify-content:center;padding:18px 20px 20px 20px;background:#f8fafc}",

      ".swal-btn{border:0;border-radius:10px;padding:10px 14px;font-weight:700;cursor:pointer;transition:transform .05s ease,opacity .15s ease}",
      ".swal-btn:active{transform:translateY(1px)}",
      ".swal-btn-cancel{background:#e5e7eb;color:#0f172a}",
      ".swal-btn-cancel:hover{opacity:.9}",
      ".swal-btn-confirm{background:#4f46e5;color:#fff}",
      ".swal-btn-confirm:hover{opacity:.95}",
      ".swal-btn:focus{outline:2px solid #6366f1;outline-offset:2px}",
      "@keyframes swal-pop{to{transform:none;opacity:1}}",
      '@media (prefers-color-scheme: dark){.swal-card{background:#0b1220;color:#e5e7eb}.swal-content{color:#cbd5e1}.swal-actions{background:#0b1220}.swal-btn-cancel{background:#1f2937;color:#e5e7eb}.swal-btn-confirm{background:#6366f1}.swal-icon{color:#fbbf24}}'
    ].join("");
    var style = document.createElement("style");
    style.id = "swal-lite-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function _iconSvg(type) {
    // 필요한 것만: warning / (원하면 success,error,info,question 추가 가능)
    if (type === "warning") {
      return (
        '<svg class="swal-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">' +
          '<path d="M12 3l9 16H3L12 3z" stroke-width="1.5"/>' +
          '<path d="M12 9v5" stroke-width="2" stroke-linecap="round"/>' +
          '<circle cx="12" cy="16.5" r="1" fill="currentColor"/>' +
        '</svg>'
      );
    }
    return ""; // 기본은 아이콘 없음
  }

  var Swal = {
    fire: function (opts) {
      opts = opts || {};
      var title = opts.title || "";
      var text  = (typeof opts.text !== "undefined") ? String(opts.text) : "";
      var showCancelButton = !!opts.showCancelButton;
      var confirmButtonText = opts.confirmButtonText || "OK";
      var cancelButtonText  = opts.cancelButtonText  || "Cancel";
      var allowOutsideClick = (typeof opts.allowOutsideClick === "boolean") ? opts.allowOutsideClick : true;
      var allowEscapeKey    = (typeof opts.allowEscapeKey === "boolean") ? opts.allowEscapeKey : true;
      var icon = opts.icon || ""; // 'warning' 지원

      // <dialog> 미지원 → 네이티브 confirm/alert 폴백(아이콘 커스텀 불가)
      if (!("HTMLDialogElement" in window)) {
        var header = title ? String(title) + "\n" : "";
        var body = header + (typeof opts.text !== "undefined" ? String(opts.text) : "");
        if (showCancelButton) {
          var ok = window.confirm(body);
          return Promise.resolve({ isConfirmed: ok, isDismissed: !ok, dismiss: ok ? undefined : "cancel" });
        }
        window.alert(body);
        return Promise.resolve({ isConfirmed: true, isDismissed: false });
      }

      _injectStylesOnce();

      return new Promise(function (resolve) {
        var dlg = document.createElement("dialog");
        dlg.className = "swal-lite";

        var headerHtml =
          '<div class="swal-header">' +
            (icon ? _iconSvg(icon) : "") +
            (title ? '<h3 class="swal-title">' + _escapeHtml(title) + "</h3>" : "") +
          "</div>";

        var contentHtml = text
          ? '<div class="swal-content">' + _escapeHtml(text) + "</div>"
          : "";

        var btns = [
          showCancelButton ? '<button class="swal-btn swal-btn-cancel" data-role="cancel" type="button">' + _escapeHtml(cancelButtonText) + "</button>" : "",
          '<button class="swal-btn swal-btn-confirm" data-role="confirm" type="button" autofocus>' + _escapeHtml(confirmButtonText) + "</button>"
        ].join("");

        dlg.innerHTML =
          '<div class="swal-card" role="dialog" aria-modal="true">' +
            headerHtml + contentHtml +
            '<div class="swal-actions">' + btns + "</div>" +
          "</div>";

        document.body.appendChild(dlg);
        dlg.showModal();

        var btnConfirm = dlg.querySelector('[data-role="confirm"]');
        var btnCancel  = dlg.querySelector('[data-role="cancel"]');

        function close(kind) {
          try { dlg.close(); } catch(_) {}
          dlg.remove();
          resolve({
            isConfirmed: kind === "confirm",
            isDismissed: kind !== "confirm",
            dismiss: kind === "cancel" ? "cancel" : (kind === "esc" ? "esc" : (kind === "backdrop" ? "backdrop" : undefined))
          });
        }

        if (btnConfirm) btnConfirm.addEventListener("click", function(){ close("confirm"); });
        if (btnCancel)  btnCancel.addEventListener("click",  function(){ close("cancel");  });

        dlg.addEventListener("cancel", function(e){
          if (!allowEscapeKey) { e.preventDefault(); return; }
          close("esc");
        });

        if (allowOutsideClick) {
          dlg.addEventListener("click", function(e){
            var card = dlg.querySelector(".swal-card");
            if (!card) return;
            if (!card.contains(e.target)) close("backdrop");
          });
        }

        (btnConfirm || dlg).focus();
      });
    }
  };

  // UMD-ish + ESM export
  if (typeof module !== "undefined" && module.exports) module.exports = { Swal: Swal };
  if (typeof window !== "undefined") window.__export_Swal__ = Swal;
})();
export const Swal = (typeof window !== "undefined" && window.__export_Swal__) ? window.__export_Swal__ : undefined;
